import { Organization, Owner } from "./ControlPanel";
import { AccessLevel } from "./generics";

export enum EnvironmentType {
  Number = "number",
  String = "string",
  Email = "email",
  Token = "token",
  JSON = "json",
}

export const environmentTypesOptions = Object.entries(EnvironmentType).map(([label, value]) => ({ label, value }));

export class Environment {
  id?: number;
  type: string;
  name: string;
  description?: string;
  value: string | number;
  tags?: string[];
  ownerId?: string;
  ownerName?: string;
  organizationId?: string;
  owner?: Owner;
  organization?: Organization;
  accessLevel: AccessLevel;
  createDateTime?: string;
  img?: string;

  constructor() {
    this.name = '';
    this.type = EnvironmentType.String;
    this.value = '';
    this.accessLevel = AccessLevel.PUBLIC;
  }
}